import { Primary100 } from "../fundations/effects/focusRing";
import { getToggleToken } from "../fundations/palette/colorTokens";
export const Switch = {
    MuiSwitch: {
        defaultProps: {
            size: "small",
            disableRipple: true
        },
        styleOverrides: {
            root: ({ theme })=>({
                    overflow: "visible",
                    /* ==== STYLING FOR SMALL SWITCH ==== */ "&.MuiSwitch-sizeSmall": {
                        width: 36,
                        height: 20,
                        padding: 0,
                        "&:active": {
                            // Increase the width of the thumb as an animation effect
                            "& .MuiSwitch-thumb": {
                                width: 19
                            },
                            "& .MuiSwitch-switchBase.Mui-checked": {
                                // Move the thumb to the right to fill the track correctly
                                transform: "translateX(13px)"
                            }
                        },
                        "&:hover": {
                            "& .MuiSwitch-track": {
                                backgroundColor: getToggleToken("toggleUnselectedHover", theme)
                            }
                        },
                        "& .MuiSwitch-switchBase": {
                            padding: 2,
                            "&.Mui-checked": {
                                transform: "translateX(16px)",
                                color: getToggleToken("toggleSelectedThumb", theme),
                                "&:hover": {
                                    "& + .MuiSwitch-track": {
                                        backgroundColor: getToggleToken("toggleSelectedHover", theme)
                                    }
                                },
                                "& + .MuiSwitch-track": {
                                    opacity: 1,
                                    backgroundColor: getToggleToken("toggleSelected", theme)
                                }
                            },
                            "&.Mui-disabled .MuiSwitch-thumb": {
                                color: getToggleToken("toggleThumbDisabled", theme),
                                opacity: 1
                            },
                            "&.Mui-disabled + .MuiSwitch-track": {
                                backgroundColor: getToggleToken("toggleDisabled", theme),
                                opacity: 1
                            },
                            "&.Mui-focusVisible .MuiSwitch-thumb": {
                                boxShadow: Primary100
                            }
                        },
                        "& .MuiSwitch-thumb": {
                            width: 16,
                            height: 16,
                            borderRadius: 16,
                            transition: theme.transitions.create([
                                "width"
                            ], {
                                duration: 200
                            })
                        },
                        "& .MuiSwitch-track": {
                            borderRadius: 36 / 2,
                            opacity: 1,
                            backgroundColor: getToggleToken("toggleUnselected", theme)
                        }
                    },
                    /* ==== STYLING FOR MEDIUM SWITCH ==== */ "&.MuiSwitch-sizeMedium": {
                        width: 44,
                        height: 24,
                        padding: 0,
                        "&:active": {
                            "& .MuiSwitch-thumb": {
                                width: 22
                            },
                            "& .MuiSwitch-switchBase.Mui-checked": {
                                transform: "translateX(18px)"
                            }
                        },
                        "&:hover": {
                            "& .MuiSwitch-track": {
                                backgroundColor: getToggleToken("toggleUnselectedHover", theme)
                            }
                        },
                        "& .MuiSwitch-switchBase": {
                            padding: 2,
                            "&.Mui-focusVisible .MuiSwitch-thumb": {
                                boxShadow: Primary100
                            },
                            "&.Mui-checked": {
                                transform: "translateX(20px)",
                                color: getToggleToken("toggleSelectedThumb", theme),
                                "&:hover": {
                                    "& + .MuiSwitch-track": {
                                        backgroundColor: getToggleToken("toggleSelectedHover", theme)
                                    }
                                },
                                "& + .MuiSwitch-track": {
                                    opacity: 1,
                                    backgroundColor: getToggleToken("toggleSelected", theme)
                                }
                            },
                            "&.Mui-disabled .MuiSwitch-thumb": {
                                color: getToggleToken("toggleThumbDisabled", theme),
                                opacity: 1
                            },
                            "&.Mui-disabled + .MuiSwitch-track": {
                                backgroundColor: getToggleToken("toggleDisabled", theme),
                                opacity: 1
                            }
                        },
                        "& .MuiSwitch-thumb": {
                            width: 20,
                            height: 20,
                            borderRadius: 20,
                            transition: theme.transitions.create([
                                "width"
                            ], {
                                duration: 200
                            })
                        },
                        "& .MuiSwitch-track": {
                            borderRadius: 44 / 2,
                            opacity: 1,
                            backgroundColor: getToggleToken("toggleUnselected", theme)
                        }
                    }
                })
        }
    }
};

//# sourceMappingURL=Switch.js.map